import { numberFormatter, shortDatePlusTimeFormatter } from "../../gridFormatters";

export const backupsRuntime = [
    {
        "field": "backup_job_name",
        "headerName": "Job Name",
        "enableRowGroup": true,
        "filter": "agSetColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "shortest_run_time",
        "headerName": "Shortest Runtime",
        "suppressColumnsToolPanel": true,
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter
    },
    {
        "field": "longest_run_time",
        "headerName": "Longest Runtime",
        "enableRowGroup": true,
        "filter": "agDateColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter
    },
    {
        "field": "most_recent_run_time",
        "headerName": "Latest Runtime",
        "enableRowGroup": true,
        "filter": "agDateColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellRenderer": numberFormatter
    },
];